import React, { useState, useEffect } from "react";
import { Box, Typography, useTheme, Chip } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { API_BASE_URL } from "../../config";

const Invoices = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchInvoices = async () => {
      setLoading(true);
      try {
        const authToken = sessionStorage.getItem("authToken");
        const res = await fetch(`${API_BASE_URL}/admin/payments`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ authToken, page: 1, limit: 100 }),
        });
        const data = await res.json();
        if (data.success && data.data) {
          setInvoices(data.data);
        }
      } catch (err) {
        console.error("Erreur chargement factures:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchInvoices();
  }, []);

  const columns = [
    { field: "id", headerName: "N° Facture / Reçu", flex: 0.8 },
    {
      field: "driver_name",
      headerName: "Bénéficiaire (Chauffeur)",
      flex: 1.2,
      cellClassName: "name-column--cell",
      renderCell: (params) => (
        <Box>
          <Typography fontWeight="bold" color={colors.grey[100]}>
            {params.value || params.row.driver_id}
          </Typography>
          {params.row.driver_phone && (
            <Typography variant="caption" color={colors.grey[300]}>
              {params.row.driver_phone}
            </Typography>
          )}
        </Box>
      ),
    },
    {
      field: "amount",
      headerName: "Montant Réglé",
      flex: 0.9,
      renderCell: (params) => (
        <Typography color={colors.greenAccent[500]} fontWeight="bold">
          {params.value} DZD
        </Typography>
      ),
    },
    { field: "payment_method", headerName: "Mode de Règlement", flex: 0.9 },
    { field: "reference", headerName: "Réf. Transaction", flex: 1.1 },
    {
      field: "status",
      headerName: "Statut",
      flex: 0.8,
      renderCell: (params) => (
        <Chip
          label={params.value || "Payé"}
          size="small"
          sx={{ backgroundColor: colors.greenAccent[600], color: "#fff" }}
        />
      ),
    },
    {
      field: "created_at",
      headerName: "Date de Facturation",
      flex: 1,
      renderCell: (params) => (
        <Typography variant="body2" color={colors.grey[200]}>
          {params.value ? new Date(params.value).toLocaleDateString("fr-FR", {
            day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit"
          }) : "-"}
        </Typography>
      ),
    },
  ];

  return (
    <Box m="20px">
      <Header title="FACTURES & QUITTANCES" subtitle="Journal des reçus et factures d'abonnements acquittés" />
      <Box
        m="30px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": { border: "none" },
          "& .MuiDataGrid-cell": { borderBottom: "none" },
          "& .name-column--cell": { color: colors.greenAccent[300] },
          "& .MuiDataGrid-columnHeaders": { backgroundColor: colors.blueAccent[700], borderBottom: "none" },
          "& .MuiDataGrid-virtualScroller": { backgroundColor: colors.primary[400] },
          "& .MuiDataGrid-footerContainer": { borderTop: "none", backgroundColor: colors.blueAccent[700] },
          "& .MuiCheckbox-root": { color: `${colors.greenAccent[200]} !important` },
        }}
      >
        <DataGrid rows={invoices} columns={columns} loading={loading} />
      </Box>
    </Box>
  );
};

export default Invoices;
